import { injectIntl, IntlShape } from 'react-intl';
import React, { useState } from 'react';
import { get, isEmpty } from 'lodash';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import {
  ExpertReportType,
  IVehiculeExpertise,
  IVictimExpertise,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import { VEHICULE_EXPERTISE_FIELDS } from 'containers/data-structure';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { translate } from 'containers/services/translate';
import { IConsultReport } from 'containers/CourtManagerLegalProceedings/ExpertReport/typings';
import ExpertReportDecisionDialog from 'containers/CourtManagerLegalProceedings/ExpertReport/Decision/ExpertReportDecisionDialog';
import ExpertReportDecisionRecap from 'containers/CourtManagerLegalProceedings/ExpertReport/Decision/ExpertReportDecisionRecap';
import messages from 'containers/CourtManagerLegalProceedings/ExpertReport/Decision/messages';
import {
  displayDecisionExpertise,
  getDecidedReportByField,
  showDecision,
} from 'containers/CourtManagerLegalProceedings/ExpertReport/Decision/utils';
import UpdateStepRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/UpdateStepRecap';

export interface ExpertReportDecisionProps {
  intl: IntlShape;
  setIsDecisionDialgOpen: Function;
  isManager: boolean;
  expertise: IVehiculeExpertise | IVictimExpertise;
  isDecisionDialgOpen: boolean;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  setExpertise: Function;
  isExpertReportValidated: boolean;
  expertReportState: ExpertReportType;
  requestGetDocByDocumentumId: Function;
}

const ExpertReportDecision: React.FC<ExpertReportDecisionProps> = (
  props,
): JSX.Element => {
  const [selectedExpertise, setSelectedExpertise] = useState<
    IVictimExpertise | IVehiculeExpertise | {}
  >({});

  const openDecisionDialog = () => {
    setSelectedExpertise(props.expertise);
    props.setIsDecisionDialgOpen && props.setIsDecisionDialgOpen(true);
  };
  const shouldDisplayActionButtons = displayDecisionExpertise(
    props.expertise,
    props.expertReportState,
  );
  return (
    <section className="expert-report-decision-wrapper">
      {props.isManager && shouldDisplayActionButtons && (
        <div className="decision-button">
          <PrimaryButton
            title={translate(messages.makeDecision, props)}
            background={BUTTON_COLORS.PRIMARY_BLUE}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
            onClick={openDecisionDialog}
          />
        </div>
      )}
      {showDecision(props.expertise) && (
        <ExpertReportDecisionRecap
          status={get(
            getDecidedReportByField(props.expertise),
            VEHICULE_EXPERTISE_FIELDS.STATUS,
            '',
          )}
          validator={get(
            getDecidedReportByField(props.expertise),
            VEHICULE_EXPERTISE_FIELDS.VALIDATOR,
            '',
          )}
          rejectionReason={get(
            getDecidedReportByField(props.expertise),
            VEHICULE_EXPERTISE_FIELDS.REJECTION_REASON,
            '',
          )}
          report={
            get(
              getDecidedReportByField(props.expertise),
              VEHICULE_EXPERTISE_FIELDS.CONSULTANCY_REPORT_DOCUMENT,
              {},
            ) as IConsultReport
          }
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      <UpdateStepRecap
        updatedBy={get(
          getDecidedReportByField(props.expertise),
          VEHICULE_EXPERTISE_FIELDS.UPDATED_BY,
          '',
        )}
      />

      {!isEmpty(selectedExpertise) && (
        <ExpertReportDecisionDialog
          handleCancel={props.setIsDecisionDialgOpen}
          isOpen={props.isDecisionDialgOpen}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          setExpertReport={props.setExpertise}
          expertise={selectedExpertise as IVehiculeExpertise | IVictimExpertise}
          setSelectedExpertise={setSelectedExpertise}
          isExpertReportValidated={props.isExpertReportValidated}
        />
      )}
    </section>
  );
};

export default injectIntl(ExpertReportDecision);
